export const baseEnv = {
  DEVELOPMENT: import.meta.env.VITE_DEVELOPMENT as string,
  STAGING: import.meta.env.VITE_STAGING as string,
  PRODUCTION: import.meta.env.VITE_PRODUCTION as string,
};

const maybeEnv = {
  ALLOW_PICKING_ENVS: import.meta.env.VITE_ALLOW_PICKING_ENVS as string,
};

export const envs = ['DEVELOPMENT', 'STAGING', 'PRODUCTION'] as const;

export type Env = (typeof envs)[number];

const defaultEnv = import.meta.env.VITE_ENVIRONMENT as Env;

const localStorageKey = 'current-env';

const apiUrlMap = {
  DEVELOPMENT: baseEnv.DEVELOPMENT,
  STAGING: baseEnv.STAGING,
  PRODUCTION: baseEnv.PRODUCTION,
};

const Environment = (function () {
  let instance: ReturnType<typeof createInstance>;

  function createInstance() {
    // your code to create a new instance of the object goes here
    return {
      ...baseEnv,
      setEnvironment(env: Env) {
        this.currentEnv = env;
      },
      get currentEnv() {
        return (localStorage.getItem(localStorageKey) as Env) || defaultEnv;
      },
      set currentEnv(value: Env) {
        localStorage.setItem(localStorageKey, value);
      },
      get accessDifferentEnvs() {
        return maybeEnv.ALLOW_PICKING_ENVS === 'true';
      },

      get LOCAL_API_URL(): string {
        return apiUrlMap[this.currentEnv];
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
})();

export default Environment.getInstance();
